export const ArchiveWallContainerClass = "article-view__piano-metering";
